<template>
    <div class="p-relative">

        <Toolbar :is-list="true" v-on:toolbar-button-click="onToolbarClick">
            <SearchPanel v-model="search" :has-filter="false" />
        </Toolbar>

        <FilterPanel v-if="filterDataSource" :dataSource="filterDataSource" v-bind:status.sync="status" v-bind:substatus.sync="term" />

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :item-class="itemRowBackground"
            :options.sync="options"
            :server-items-length="total"
            :items-per-page="10"
            :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
            :page.sync="options.page"
            @page-count="paginationPageCount = $event"
            class="elevation-1 customization-list-table pagination-list-table sticky-table"
            @dblclick:row="(event, data) => onRowDblClick(data.item)"
        >
            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

            <template v-slot:[`item.regnumber`]="{ item }">
                <td class="clt-col-wrap text-start">
                    <span class="clt-col-marker" :style="{ background: getColor(item) }"></span>{{ item.regnumber }}
                </td>
            </template>

            <template v-slot:[`item.regdate`]="{ item }">
                <div>{{ dateFormat(item.regdate, 'DD.MM.YYYY') }}</div>
            </template>

            <template v-slot:[`item.authorname`]="{ item }">
                <v-workplace-chip v-if="item.authorname" :id="item.authorid" :name="item.authorname" />
            </template>

            <template v-slot:[`item.ordertext`]="{ item }">
                <div class="elipsis-text-wrap">
                    <v-common-chip v-if="item.isown === false" />
                    <v-doc-type-chip :text="$t(item.isorder ? 'Поручение' : 'Задача')"/>
                    <div class="etw-text-container">
                        <div v-if="!getText(item)" class="font-italic etw-text" v-tooltip.top-center="$t('Не_указано')">
                            {{ $t('Не_указано') }}
                        </div>
                        <div v-else class="etw-text" v-tooltip.top-center="getText(item)">
                            {{ getText(item) }}
                        </div>
                    </div>
                    
                </div>
            </template>

            <template v-slot:[`item.controltype`]="{ item }">
                <StatusChip v-if="[1, 2].includes(item.controltype)" :status="getControlStatus(item.controltype)"/>
            </template>

            <template v-slot:[`item.controldate`]="{ item }">
                <div>
                    {{ dateFormat(item.controldate, 'DD.MM.YYYY') }}
                </div>
            </template>

            <template v-slot:[`item.controlername`]="{ item }">
                <v-workplace-chip v-if="item.controlername" :id="item.controlerworkplaceid" :name="item.controlername" />
            </template>

            <template v-slot:[`item.executername`]="{ item }">
                <v-workplace-chip v-if="item.executername" :id="item.executerid" :name="item.executername" />
            </template>

            <template v-slot:[`footer.prepend`]>
                <v-pagination
                    v-model="options.page"
                    :length="paginationPageCount"
                    :total-visible="$listPaginationTotal"
                    color="teal"
                ></v-pagination>
            </template>

        </v-data-table>

    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import _ from 'lodash';
import sys from '@/services/system';
import { mapGetters, mapActions } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import StatusChip from '@/components/global/chips/StatusChip';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    name: "MyOrdersList",
    components: {
        Toolbar,
        SearchPanel,
        StatusChip,
        FilterPanel
    },
    columnIndex: {        
        "ordertext": 4,
        "controldate": 5,
        "controlername": 9,
        "executername": 9,
        "regnumber" : 10,
        "regdate" : 11,
        "authorname": 13,
    },
    computed: {
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        search: {
            get: function() {
                return this.$store.getters[`orders/lists/myordersonexecution/getSearch`];
            },
            set: _.debounce(function(v) {
                this.$store.commit(`orders/lists/myordersonexecution/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`orders/lists/myordersonexecution/SET_SEARCH`, v);
            }, 500)
        },
        status: {
            get: function() {
                return this.$store.getters[`orders/lists/myordersonexecution/getStatus`];
            },
            set: function(v) {
                this.$store.commit(`orders/lists/myordersonexecution/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`orders/lists/myordersonexecution/SET_STATUS`, v);
            }
        },
        term: {
            get: function() {
                return this.$store.getters[`orders/lists/myordersonexecution/getTerm`];
            },
            set: function(v) {
                this.$store.commit(`orders/lists/myordersonexecution/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`orders/lists/myordersonexecution/SET_TERM`, v);
            }
        },
        options: {
            get: function() {
                return this.$store.getters[`orders/lists/myordersonexecution/getTableOptions`];
            },
            set: function(newValue) {
                this.$store.commit(`orders/lists/myordersonexecution/SET_TABLE_OPTION`, newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                OrderType: this.status,
                ExecutionStatus: this.term
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        },
        headers() {
            let arr =  [
                { text: this.$t("Рег._№"), value: 'regnumber', width: '150px' },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px' },
                { text: this.$t("Автор"), value: 'authorname', width: '150px' },
                { text: this.$t("Текст_задачи"), value: 'ordertext', sortable: false },
                { text: this.$t("Срок"), value: 'controldate', width: '150px' },
            ];

            return arr;
        },
    },
    data: () => {
        return {
            loading: true,

            total: 0,            
            entities: [],

            prevTableFilterObject: null,
            filterDataSource: null,

            paginationPageCount: 0
        }
    },
    methods: {
        ...mapActions('orders', ['updateCounter']),
        getControlStatus(status) {
            let statusName = 'unknown';
            
            switch (status) {
                case 1: statusName = 'control'; break;
                case 2: statusName = 'specialControl'; break;
                case 3: statusName = 'inspect'; break;
                case 4: statusName = 'forWork'; break;
                default: break;

            }

            return this.avaibleStatuses[statusName];
        },
        getText(item){
            return item.isorder && !!item.ordersubject ? item.ordersubject : item.ordertext;
        },
        resetPage() {
            this.$store.commit(`orders/lists/myordersonexecution/SET_TABLE_OPTION_PAGE`, 1);
        },
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },
        onToolbarClick(event, btn){
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        async getData(isRefresh = false) {
            this.updateCounter();
            await this.loadFilters();
            
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
            
            this.prevTableFilterObject = this.getTableFilterObject();

            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `/api/orders/list?collection=Orders.Executer&filter=${this.getTableFilterObject()}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;            
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, OrderType, ExecutionStatus } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "controldate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn];

            let filter = {
                OrderType,
                ExecutionStatus,
                SearchStr,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            };

            filter.OrderCategory = 'OnExecution';

            return JSON.stringify(filter);
        },
        async loadFilters() {
            let filterResponse = await httpAPI({ url: `api/orders/my-orders-filter?collection=Orders.Executer&filter=${this.getTableFilterObject()}`, method: 'GET' });
            this.filterDataSource = filterResponse ? filterResponse.data.Payload : null;
        },
        async oneStatusColWidth() {
            var parent = document.getElementsByClassName('content-box')[0];
            var status_col_obj = parent.getElementsByClassName('status-col');
            var status_dropdown_col_obj = parent.getElementsByClassName('status-dropdown-col');
            var status_col_w = status_col_obj.length > 0 ? status_col_obj[0].clientWidth : 0;
            if(status_dropdown_col_obj.length > 0){
                for (var index = 0; index < status_dropdown_col_obj.length; index++) {
                    status_dropdown_col_obj[index].style.width = status_col_w + "px";
                }
            }
        },
        onRowDblClick(rowItem) {
            let id = rowItem.taskid;
            let type = 'Documents|Orders|CitizenStatements.ResolutionTask';
            this.$eventBus.$emit('open-document', { id, type, common: true });
        },
        getColor(item) {
            return sys.getExecutionColorStatus(item.controldate);
        },
        dateFormat: sys.dateFormat,
    },
    mounted() {
        this.$nextTick(this.oneStatusColWidth);
        window.addEventListener('resize', this.oneStatusColWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.oneStatusColWidth);
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        }
    },
    async created() {
        let menu = [ { Action: "Refresh", Icon: "refresh", Items: null, Text: this.$t("Обновить"), ToolTip: this.$t("Обновить_форму"), Type: null } ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu });
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    }
}
</script>